const ReactAppStage = process.env.REACT_APP_API_STAGE;
console.log("REACT_APP_API_STAGE", ReactAppStage);

const dev = {
  API_ENDPOINT_URL:
    ReactAppStage == "Live"
      ? "https://api.smitahospital.com/api/v1/"
      : "https://smitatestapi.riolabz.com/api/v1/",
};

const prod = {
  API_ENDPOINT_URL:
    ReactAppStage == "Live"
      ? "https://api.smitahospital.com/api/v1/"
      : "https://smitatestapi.riolabz.com/api/v1/",
};

const test = {
  API_ENDPOINT_URL:
    ReactAppStage == "Live"
      ? "https://api.smitahospital.com/api/v1/"
      : "https://smitatestapi.riolabz.com/api/v1/",
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      break;
  }
};

export const env = getEnv();
